/**
 * A enum that includes all non-printable string values one can expect from $event.key.
 * For example, this enum includes values like "CapsLock", "Backspace", and "AudioVolumeMute",
 * but does not include values like "a", "A", "#", "é", or "¿".
 * Auto generated from MDN: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#Speech_recognition_keys
 */
var KeyboardEventKey;
(function (KeyboardEventKey) {
    /** The user agent wasn't able to map the event's virtual keycode to a specific key value. This can happen due to hardware or software constraints, or because of constraints around the platform on which the user agent is running. */
    KeyboardEventKey["Unidentified"] = "Unidentified";
    /** The Alt (Alternative) key. */
    KeyboardEventKey["Alt"] = "Alt";
    /** The AltGr or AltGraph (Alternate Graphics) key. Enables the ISO Level 3 shift modifier (where Shift is the level 2 modifier). */
    KeyboardEventKey["AltGraph"] = "AltGraph";
    /** The Caps Lock key. Toggles the capital character lock on and off for subsequent input. */
    KeyboardEventKey["CapsLock"] = "CapsLock";
    /** The Control, Ctrl, or Ctl key. Allows typing control characters. */
    KeyboardEventKey["Control"] = "Control";
    /** The Space Bar key. */
    KeyboardEventKey["SpaceBar"] = " ";
    /** The Fn (Function modifier) key. Used to allow generating function key (F1-F15, for instance) characters on keyboards without a dedicated function key area. Often handled in hardware so that events aren't generated for this key. */
    KeyboardEventKey["Fn"] = "Fn";
    /** The FnLock or F-Lock (Function Lock) key.Toggles the function key mode described by "Fn" on and off. Often handled in hardware so that events aren't generated for this key. */
    KeyboardEventKey["FnLock"] = "FnLock";
    /** The Hyper key. */
    KeyboardEventKey["Hyper"] = "Hyper";
    /** The Meta key. Allows issuing special command inputs. This is the Windows logo key, or the Command or ⌘ key on Mac keyboards. */
    KeyboardEventKey["Meta"] = "Meta";
    /** The NumLock (Number Lock) key. Toggles the numeric keypad between number entry some other mode (often directional arrows). */
    KeyboardEventKey["NumLock"] = "NumLock";
    /** The Scroll Lock key. Toggles between scrolling and cursor movement modes. */
    KeyboardEventKey["ScrollLock"] = "ScrollLock";
    /** The Shift key. Modifies keystrokes to allow typing upper (or other) case letters, and to support typing punctuation and other special characters. */
    KeyboardEventKey["Shift"] = "Shift";
    /** The Super key. */
    KeyboardEventKey["Super"] = "Super";
    /** The Symbol modifier key (found on certain virtual keyboards). */
    KeyboardEventKey["Symbol"] = "Symbol";
    /** The Symbol Lock key. */
    KeyboardEventKey["SymbolLock"] = "SymbolLock";
    /** The Enter or ↵ key (sometimes labeled Return). */
    KeyboardEventKey["Enter"] = "Enter";
    /** The Horizontal Tab key, Tab. */
    KeyboardEventKey["Tab"] = "Tab";
    /** The down arrow key. */
    KeyboardEventKey["ArrowDown"] = "ArrowDown";
    /** The left arrow key. */
    KeyboardEventKey["ArrowLeft"] = "ArrowLeft";
    /** The right arrow key. */
    KeyboardEventKey["ArrowRight"] = "ArrowRight";
    /** The up arrow key. */
    KeyboardEventKey["ArrowUp"] = "ArrowUp";
    /** The End key. Moves to the end of content. */
    KeyboardEventKey["End"] = "End";
    /** The Home key. Moves to the start of content. */
    KeyboardEventKey["Home"] = "Home";
    /** The Page Down (or PgDn) key. Scrolls down or displays the next page of content. */
    KeyboardEventKey["PageDown"] = "PageDown";
    /** The Page Up (or PgUp) key. Scrolls up or displays the previous page of content. */
    KeyboardEventKey["PageUp"] = "PageUp";
    /** The Backspace key. This key is labeled Delete on Mac keyboards. */
    KeyboardEventKey["Backspace"] = "Backspace";
    /** The Clear key. Removes the currently selected input. */
    KeyboardEventKey["Clear"] = "Clear";
    /** The Copy key (on certain extended keyboards). */
    KeyboardEventKey["Copy"] = "Copy";
    /** The Cursor Select key, CrSel. */
    KeyboardEventKey["CrSel"] = "CrSel";
    /** The Cut key (on certain extended keyboards). */
    KeyboardEventKey["Cut"] = "Cut";
    /** The Delete key, Del. */
    KeyboardEventKey["Delete"] = "Delete";
    /** Erase to End of Field. Deletes all characters from the current cursor position to the end of the current field. */
    KeyboardEventKey["EraseEof"] = "EraseEof";
    /** The ExSel (Extend Selection) key. */
    KeyboardEventKey["ExSel"] = "ExSel";
    /** The Insert key, Ins. Toggles  between inserting and overwriting text. */
    KeyboardEventKey["Insert"] = "Insert";
    /** Paste from the clipboard. */
    KeyboardEventKey["Paste"] = "Paste";
    /** Redo the last action. */
    KeyboardEventKey["Redo"] = "Redo";
    /** Undo the last action. */
    KeyboardEventKey["Undo"] = "Undo";
    /** The Accept, Commit, or OK key or button. Accepts the currently selected option or input method sequence conversion. */
    KeyboardEventKey["Accept"] = "Accept";
    /** The Again key. Redoes or repeats a previous action. */
    KeyboardEventKey["Again"] = "Again";
    /** The Attn (Attention) key. */
    KeyboardEventKey["Attn"] = "Attn";
    /** The Cancel key. */
    KeyboardEventKey["Cancel"] = "Cancel";
    /** Shows the context menu. Typically found between the Windows (or OS) key and the Control key on the right side of the keyboard. */
    KeyboardEventKey["ContextMenu"] = "ContextMenu";
    /** The Escape (Esc) key. Typically used as an exit, cancel, or "escape this operation" button. Historically, the Escape character was used to signal the start of a special control sequence of characters called an "escape sequence." */
    KeyboardEventKey["Escape"] = "Escape";
    /** The Execute key. */
    KeyboardEventKey["Execute"] = "Execute";
    /** The Find key. Opens an interface (typically a dialog box) for performing a find/search operation. */
    KeyboardEventKey["Find"] = "Find";
    /** The Finish key. */
    KeyboardEventKey["Finish"] = "Finish";
    /** The Help key. Opens or toggles the display of help information. */
    KeyboardEventKey["Help"] = "Help";
    /**
     * The Pause key. Pauses the current application or state, if applicable.
     * This shouldn't be confused with the "MediaPause" key value, which is used for media controllers, rather than to control applications and processes.
     */
    KeyboardEventKey["Pause"] = "Pause";
    /**
     * The Play key. Resumes a previously paused application, if applicable.
     * This shouldn't be confused with the "MediaPlay" key value, which is used for media controllers, rather than to control applications and processes.
     */
    KeyboardEventKey["Play"] = "Play";
    /** The Props (Properties) key. */
    KeyboardEventKey["Props"] = "Props";
    /** The Select key. */
    KeyboardEventKey["Select"] = "Select";
    /** The ZoomIn key. */
    KeyboardEventKey["ZoomIn"] = "ZoomIn";
    /** The ZoomOut key. */
    KeyboardEventKey["ZoomOut"] = "ZoomOut";
    /** The Brightness Down key. Typically used to reduce the brightness of the display. */
    KeyboardEventKey["BrightnessDown"] = "BrightnessDown";
    /** The Brightness Up key. Typically increases the brightness of the display. */
    KeyboardEventKey["BrightnessUp"] = "BrightnessUp";
    /** The Eject key. Ejects removable media (or toggles an optical storage device tray open and closed). */
    KeyboardEventKey["Eject"] = "Eject";
    /** The LogOff key. */
    KeyboardEventKey["LogOff"] = "LogOff";
    /**
     * The Power button or key, to toggle power on and off.
     * Not all systems pass this key through to to the user agent.
     */
    KeyboardEventKey["Power"] = "Power";
    /** The PowerOff or PowerDown key. Shuts off the system. */
    KeyboardEventKey["PowerOff"] = "PowerOff";
    /** The PrintScreen or PrtScr key. Sometimes SnapShot. Captures the screen and prints it or saves it to disk. */
    KeyboardEventKey["PrintScreen"] = "PrintScreen";
    /** The Hibernate key. This saves the state of the computer to disk and then shuts down; the computer can be returned to its previous state by restoring the saved state information. */
    KeyboardEventKey["Hibernate"] = "Hibernate";
    /** The Standby key; also known as Suspend or Sleep. This turns off the display and puts the computer in a low power consumption mode, without completely powering off. */
    KeyboardEventKey["Standby"] = "Standby";
    /** The WakeUp key; used to wake the computer from the hibernation or standby modes. */
    KeyboardEventKey["WakeUp"] = "WakeUp";
    /** The All Candidates key, which starts multi-candidate mode, in which multiple candidates are displayed for the ongoing input. */
    KeyboardEventKey["AllCandidates"] = "AllCandidates";
    /** The Alphanumeric key. */
    KeyboardEventKey["Alphanumeric"] = "Alphanumeric";
    /** The Code Input key, which enables code input mode, which lets the user enter characters by typing their code points (their Unicode character numbers, typically). */
    KeyboardEventKey["CodeInput"] = "CodeInput";
    /** The Compose key. */
    KeyboardEventKey["Compose"] = "Compose";
    /** The Convert key, which instructs the IME to convert the current input method sequence into the resulting character. */
    KeyboardEventKey["Convert"] = "Convert";
    /** A dead "combining" key; that is, a key which is used in tandem with other keys to generate accented and other modified characters. If pressed by itself, it doesn't generate a character. If you wish to identify which specific dead key was pressed (in cases where more than one exists), you can do so by examining the KeyboardEvent's associated compositionupdate event's  data property. */
    KeyboardEventKey["Dead"] = "Dead";
    /** The Final (Final Mode) key is used on some Asian keyboards to enter final mode when using IMEs. */
    KeyboardEventKey["FinalMode"] = "FinalMode";
    /** Switches to the first character group on an ISO/IEC 9995 keyboard. Each key may have multiple groups of characters, each in its own column. Pressing this key instructs the device to interpret keypresses as coming from the first column on subsequent keystrokes. */
    KeyboardEventKey["GroupFirst"] = "GroupFirst";
    /** Switches to the last character group on an ISO/IEC 9995 keyboard. */
    KeyboardEventKey["GroupLast"] = "GroupLast";
    /** Switches to the next character group on an ISO/IEC 9995 keyboard. */
    KeyboardEventKey["GroupNext"] = "GroupNext";
    /** Switches to the previous character group on an ISO/IEC 9995 keyboard. */
    KeyboardEventKey["GroupPrevious"] = "GroupPrevious";
    /** The Mode Change key. Toggles or cycles among input modes of IMEs. */
    KeyboardEventKey["ModeChange"] = "ModeChange";
    /** The Next Candidate function key. Selects the next possible match for the ongoing input. */
    KeyboardEventKey["NextCandidate"] = "NextCandidate";
    /** The NonConvert ("Don't convert") key. This accepts the current input method sequence without running conversion when using an IME. */
    KeyboardEventKey["NonConvert"] = "NonConvert";
    /** The Previous Candidate key. Selects the previous possible match for the ongoing input. */
    KeyboardEventKey["PreviousCandidate"] = "PreviousCandidate";
    /** The Process key. Instructs the IME to process the conversion. */
    KeyboardEventKey["Process"] = "Process";
    /** The Single Candidate key. Enables single candidate mode (as opposed to multi-candidate mode); in this mode, only one candidate is displayed at a time. */
    KeyboardEventKey["SingleCandidate"] = "SingleCandidate";
    /** The Hangul (Korean character set) mode key, which toggles between Hangul and English entry modes. */
    KeyboardEventKey["HangulMode"] = "HangulMode";
    /** Selects the Hanja mode, for converting Hangul characters to the more specific Hanja characters. */
    KeyboardEventKey["HanjaMode"] = "HanjaMode";
    /** Selects the Junja mode, in which Korean is represented using single-byte Latin characters. */
    KeyboardEventKey["JunjaMode"] = "JunjaMode";
    /** The Eisu key. This key's purpose is defined by the IME, but may be used to close the IME. */
    KeyboardEventKey["Eisu"] = "Eisu";
    /** The Hankaku (half-width characters) key. */
    KeyboardEventKey["Hankaku"] = "Hankaku";
    /** The Hiragana key; selects Kana characters mode. */
    KeyboardEventKey["Hiragana"] = "Hiragana";
    /** Toggles between the Hiragana and Katakana writing systems. */
    KeyboardEventKey["HiraganaKatakana"] = "HiraganaKatakana";
    /** The Kana Mode (Kana Lock) key. */
    KeyboardEventKey["KanaMode"] = "KanaMode";
    /** The Kanji Mode key. Enables entering Japanese text using the ideographic characters of Chinese origin. */
    KeyboardEventKey["KanjiMode"] = "KanjiMode";
    /** The Katakana key. */
    KeyboardEventKey["Katakana"] = "Katakana";
    /** The Romaji key; selects the Roman character set. */
    KeyboardEventKey["Romaji"] = "Romaji";
    /** The Zenkaku (full width) characters key. */
    KeyboardEventKey["Zenkaku"] = "Zenkaku";
    /** The Zenkaku/Hankaku (full width/half width) toggle key. */
    KeyboardEventKey["ZenkakuHanaku"] = "ZenkakuHanaku";
    /** The first general-purpose function key, F1. */
    KeyboardEventKey["F1"] = "F1";
    /** The F2 key. */
    KeyboardEventKey["F2"] = "F2";
    /** The F3 key. */
    KeyboardEventKey["F3"] = "F3";
    /** The F4 key. */
    KeyboardEventKey["F4"] = "F4";
    /** The F5 key. */
    KeyboardEventKey["F5"] = "F5";
    /** The F6 key. */
    KeyboardEventKey["F6"] = "F6";
    /** The F7 key. */
    KeyboardEventKey["F7"] = "F7";
    /** The F8 key. */
    KeyboardEventKey["F8"] = "F8";
    /** The F9 key. */
    KeyboardEventKey["F9"] = "F9";
    /** The F10 key. */
    KeyboardEventKey["F10"] = "F10";
    /** The F11 key. */
    KeyboardEventKey["F11"] = "F11";
    /** The F12 key. */
    KeyboardEventKey["F12"] = "F12";
    /** The F13 key. */
    KeyboardEventKey["F13"] = "F13";
    /** The F14 key. */
    KeyboardEventKey["F14"] = "F14";
    /** The F15 key. */
    KeyboardEventKey["F15"] = "F15";
    /** The F16 key. */
    KeyboardEventKey["F16"] = "F16";
    /** The F17 key. */
    KeyboardEventKey["F17"] = "F17";
    /** The F18 key. */
    KeyboardEventKey["F18"] = "F18";
    /** The F19 key. */
    KeyboardEventKey["F19"] = "F19";
    /** The F20 key. */
    KeyboardEventKey["F20"] = "F20";
    /** The first general-purpose virtual function key. */
    KeyboardEventKey["Soft1"] = "Soft1";
    /** The second general-purpose virtual function key. */
    KeyboardEventKey["Soft2"] = "Soft2";
    /** The third general-purpose virtual function key. */
    KeyboardEventKey["Soft3"] = "Soft3";
    /** The fourth general-purpose virtual function key. */
    KeyboardEventKey["Soft4"] = "Soft4";
    /** Presents a list of recently-used applications which lets the user change apps quickly. */
    KeyboardEventKey["AppSwitch"] = "AppSwitch";
    /** The Call key; dials the number which has been entered. */
    KeyboardEventKey["Call"] = "Call";
    /** The Camera key; activates the camera. */
    KeyboardEventKey["Camera"] = "Camera";
    /** The Focus key; focuses the camera. */
    KeyboardEventKey["CameraFocus"] = "CameraFocus";
    /** The End Call or Hang Up button. */
    KeyboardEventKey["EndCall"] = "EndCall";
    /** The Back button. */
    KeyboardEventKey["GoBack"] = "GoBack";
    /** The Home button, which takes the user to the phone's main screen (usually an application launcher). */
    KeyboardEventKey["GoHome"] = "GoHome";
    /** The Headset Hook key. This is typically actually a button on the headset which is used to hang up calls and play or pause media. */
    KeyboardEventKey["HeadsetHook"] = "HeadsetHook";
    /** The Redial button, which redials the last-called number. */
    KeyboardEventKey["LastNumberRedial"] = "LastNumberRedial";
    /** The Notification key. */
    KeyboardEventKey["Notification"] = "Notification";
    /** A button which cycles among the notification modes: silent, vibrate, ring, and so forth. */
    KeyboardEventKey["MannerMode"] = "MannerMode";
    /** The Voice Dial key. Initiates voice dialing. */
    KeyboardEventKey["VoiceDial"] = "VoiceDial";
    /** Switches to the previous channel. */
    KeyboardEventKey["ChannelDown"] = "ChannelDown";
    /** Switches to the next channel. */
    KeyboardEventKey["ChannelUp"] = "ChannelUp";
    /** Starts, continues, or increases the speed of fast forwarding the media. */
    KeyboardEventKey["MediaFastForward"] = "MediaFastForward";
    /** Pauses the currently playing media. Some older applications use simply "Pause" but this is not correct. */
    KeyboardEventKey["MediaPause"] = "MediaPause";
    /** Starts or continues playing media at normal speed, if not already doing so. Has no effect otherwise. */
    KeyboardEventKey["MediaPlay"] = "MediaPlay";
    /** Toggles between playing and pausing the current media. */
    KeyboardEventKey["MediaPlayPause"] = "MediaPlayPause";
    /** Starts or resumes recording media. */
    KeyboardEventKey["MediaRecord"] = "MediaRecord";
    /** Starts, continues, or increases the speed of rewinding the media. */
    KeyboardEventKey["MediaRewind"] = "MediaRewind";
    /** Stops the current media activity (such as playing, recording, pausing, forwarding, or rewinding). Has no effect if the media is currently stopped already. */
    KeyboardEventKey["MediaStop"] = "MediaStop";
    /** Seeks to the next media or program track. */
    KeyboardEventKey["MediaTrackNext"] = "MediaTrackNext";
    /** Seeks to the previous media or program track. */
    KeyboardEventKey["MediaTrackPrevious"] = "MediaTrackPrevious";
    /** Adjusts audio balance toward the left. */
    KeyboardEventKey["AudioBalanceLeft"] = "AudioBalanceLeft";
    /** Adjusts audio balance twoard the right. */
    KeyboardEventKey["AudioBalanceRight"] = "AudioBalanceRight";
    /** Decreases the amount of bass. */
    KeyboardEventKey["AudioBassDown"] = "AudioBassDown";
    /** Reduces bass boosting or cycles downward through bass boost modes or states. */
    KeyboardEventKey["AudioBassBoostDown"] = "AudioBassBoostDown";
    /** Toggles bass boosting on and off. */
    KeyboardEventKey["AudioBassBoostToggle"] = "AudioBassBoostToggle";
    /** Increases the amoung of bass boosting, or cycles upward through a set of bass boost modes or states. */
    KeyboardEventKey["AudioBassBoostUp"] = "AudioBassBoostUp";
    /** Increases the amount of bass. */
    KeyboardEventKey["AudioBassUp"] = "AudioBassUp";
    /** Adjusts the audio fader toward the front. */
    KeyboardEventKey["AudioFaderFront"] = "AudioFaderFront";
    /** Adjustts the audio fader toward the rear. */
    KeyboardEventKey["AudioFaderRear"] = "AudioFaderRear";
    /** Selects the next available surround sound mode. */
    KeyboardEventKey["AudioSurroundModeNext"] = "AudioSurroundModeNext";
    /** Decreases the amount of treble. */
    KeyboardEventKey["AudioTrebleDown"] = "AudioTrebleDown";
    /** Increases the amount of treble. */
    KeyboardEventKey["AudioTrebleUp"] = "AudioTrebleUp";
    /** Decreases the audio volume. */
    KeyboardEventKey["AudioVolumeDown"] = "AudioVolumeDown";
    /** Mutes the audio. */
    KeyboardEventKey["AudioVolumeMute"] = "AudioVolumeMute";
    /** Increases the audio volume. */
    KeyboardEventKey["AudioVolumeUp"] = "AudioVolumeUp";
    /** Toggles the microphone on and off. */
    KeyboardEventKey["MicrophoneToggle"] = "MicrophoneToggle";
    /** Decreases the microphone's input volume. */
    KeyboardEventKey["MicrophoneVolumeDown"] = "MicrophoneVolumeDown";
    /** Mutes the microphone input. */
    KeyboardEventKey["MicrophoneVolumeMute"] = "MicrophoneVolumeMute";
    /** Increases the microphone's input volume. */
    KeyboardEventKey["MicrophoneVolumeUp"] = "MicrophoneVolumeUp";
    /** Switches into TV viewing mode. */
    KeyboardEventKey["TV"] = "TV";
    /** Toggles 3D TV mode on and off. */
    KeyboardEventKey["TV3DMode"] = "TV3DMode";
    /** Toggles between antenna and cable inputs. */
    KeyboardEventKey["TVAntennaCable"] = "TVAntennaCable";
    /** Toggles audio description mode on and off. */
    KeyboardEventKey["TVAudioDescription"] = "TVAudioDescription";
    /** Decreases the audio description's mixing volume; reduces the volume of the audio descriptions relative to the program sound. */
    KeyboardEventKey["TVAudioDescriptionMixDown"] = "TVAudioDescriptionMixDown";
    /** Increases the audio description's mixing volume; increases the volume of the audio descriptions relative to the program sound. */
    KeyboardEventKey["TVAudioDescriptionMixUp"] = "TVAudioDescriptionMixUp";
    /** Displays or hides the media contents available for playback (this may be a channel guide showing the currently airing programs, or a list of media files to play). */
    KeyboardEventKey["TVContentsMenu"] = "TVContentsMenu";
    /** Displays or hides the TV's data service menu. */
    KeyboardEventKey["TVDataService"] = "TVDataService";
    /** Cycles the input mode on an external TV. */
    KeyboardEventKey["TVInput"] = "TVInput";
    /** Switches to the input "Component 1." */
    KeyboardEventKey["TVInputComponent1"] = "TVInputComponent1";
    /** Switches to the input "Component 2." */
    KeyboardEventKey["TVInputComponent2"] = "TVInputComponent2";
    /** Switches to the input "Composite 1." */
    KeyboardEventKey["TVInputComposite1"] = "TVInputComposite1";
    /** Switches to the input "Composite 2." */
    KeyboardEventKey["TVInputComposite2"] = "TVInputComposite2";
    /** Switches to the input "HDMI 1." */
    KeyboardEventKey["TVInputHDMI1"] = "TVInputHDMI1";
    /** Switches to the input "HDMI 2." */
    KeyboardEventKey["TVInputHDMI2"] = "TVInputHDMI2";
    /** Switches to the input "HDMI 3." */
    KeyboardEventKey["TVInputHDMI3"] = "TVInputHDMI3";
    /** Switches to the input "HDMI 4." */
    KeyboardEventKey["TVInputHDMI4"] = "TVInputHDMI4";
    /** Switches to the input "VGA 1." */
    KeyboardEventKey["TVInputVGA1"] = "TVInputVGA1";
    /** The Media Context menu key. */
    KeyboardEventKey["TVMediaContext"] = "TVMediaContext";
    /** Toggle the TV's network connection on and off. */
    KeyboardEventKey["TVNetwork"] = "TVNetwork";
    /** Put the TV into number entry mode. */
    KeyboardEventKey["TVNumberEntry"] = "TVNumberEntry";
    /** The device's power button. */
    KeyboardEventKey["TVPower"] = "TVPower";
    /** Radio button. */
    KeyboardEventKey["TVRadioService"] = "TVRadioService";
    /** Satellite button. */
    KeyboardEventKey["TVSatellite"] = "TVSatellite";
    /** Broadcast Satellite button. */
    KeyboardEventKey["TVSatelliteBS"] = "TVSatelliteBS";
    /** Communication Satellite button. */
    KeyboardEventKey["TVSatelliteCS"] = "TVSatelliteCS";
    /** Toggles among available satellites. */
    KeyboardEventKey["TVSatelliteToggle"] = "TVSatelliteToggle";
    /** Selects analog terrestrial television service (analog cable or antenna reception). */
    KeyboardEventKey["TVTerrestrialAnalog"] = "TVTerrestrialAnalog";
    /** Selects digital terrestrial television service (digital cable or antenna receiption). */
    KeyboardEventKey["TVTerrestrialDigital"] = "TVTerrestrialDigital";
    /** Timer programming button. */
    KeyboardEventKey["TVTimer"] = "TVTimer";
    /** Changes the input mode on an external audio/video receiver (AVR) unit. */
    KeyboardEventKey["AVRInput"] = "AVRInput";
    /** Toggles the power on an external AVR unit. */
    KeyboardEventKey["AVRPower"] = "AVRPower";
    /** General-purpose media function key, color-coded red; this has index 0 among the colored keys. */
    KeyboardEventKey["ColorF0Red"] = "ColorF0Red";
    /** General-purpose media function key, color-coded green; this has index 1 among the colored keys. */
    KeyboardEventKey["ColorF1Green"] = "ColorF1Green";
    /** General-purpose media function key, color-coded yellow; this has index 2 among the colored keys. */
    KeyboardEventKey["ColorF2Yellow"] = "ColorF2Yellow";
    /** General-purpose media function key, color-coded blue; this has index 3 among the colored keys. */
    KeyboardEventKey["ColorF3Blue"] = "ColorF3Blue";
    /** General-purpose media function key, color-coded grey; this has index 4 among the colored keys. */
    KeyboardEventKey["ColorF4Grey"] = "ColorF4Grey";
    /** General-purpose media function key, color-coded brown; this has index 5 among the colored keys. */
    KeyboardEventKey["ColorF5Brown"] = "ColorF5Brown";
    /** Toggles closed captioning on and off. */
    KeyboardEventKey["ClosedCaptionToggle"] = "ClosedCaptionToggle";
    /** Adjusts the brightness of the device by toggling between two brightness levels or by cycling among multiple brightness levels. */
    KeyboardEventKey["Dimmer"] = "Dimmer";
    /** Cycles among video sources. */
    KeyboardEventKey["DisplaySwap"] = "DisplaySwap";
    /** Switches the input source to the Digital Video Recorder (DVR). */
    KeyboardEventKey["DVR"] = "DVR";
    /** The Exit button, which exits the current application or menu. */
    KeyboardEventKey["Exit"] = "Exit";
    /** Clears the program or content stored in the first favorites list slot. */
    KeyboardEventKey["FavoriteClear0"] = "FavoriteClear0";
    /** Clears the program or content stored in the second favorites list slot. */
    KeyboardEventKey["FavoriteClear1"] = "FavoriteClear1";
    /** Clears the program or content stored in the third favorites list slot. */
    KeyboardEventKey["FavoriteClear2"] = "FavoriteClear2";
    /** Clears the program or content stored in the fourth favorites list slot. */
    KeyboardEventKey["FavoriteClear3"] = "FavoriteClear3";
    /** Selects (recalls) the program or content stored in the first favorites list slot. */
    KeyboardEventKey["FavoriteRecall0"] = "FavoriteRecall0";
    /** Selects (recalls) the program or content stored in the second favorites list slot. */
    KeyboardEventKey["FavoriteRecall1"] = "FavoriteRecall1";
    /** Selects (recalls) the program or content stored in the third favorites list slot. */
    KeyboardEventKey["FavoriteRecall2"] = "FavoriteRecall2";
    /** Selects (recalls) the program or content stored in the fourth favorites list slot. */
    KeyboardEventKey["FavoriteRecall3"] = "FavoriteRecall3";
    /** Stores the current program or content into the first favorites list slot. */
    KeyboardEventKey["FavoriteStore0"] = "FavoriteStore0";
    /** Stores the current program or content into the second favorites list slot. */
    KeyboardEventKey["FavoriteStore1"] = "FavoriteStore1";
    /** Stores the current program or content into the third favorites list slot. */
    KeyboardEventKey["FavoriteStore2"] = "FavoriteStore2";
    /** Stores the current program or content into the fourth favorites list slot. */
    KeyboardEventKey["FavoriteStore3"] = "FavoriteStore3";
    /** Toggles the display of the program or content guide. */
    KeyboardEventKey["Guide"] = "Guide";
    /** If the guide is currently displayed, this button tells the guide to display the next day's content. */
    KeyboardEventKey["GuideNextDay"] = "GuideNextDay";
    /** If the guide is currently displayed, this button tells the guide to display the previous day's content. */
    KeyboardEventKey["GuidePreviousDay"] = "GuidePreviousDay";
    /** Toggles the display of information about the currently selected content, program, or media. */
    KeyboardEventKey["Info"] = "Info";
    /** Tells the device to perform an instant replay (typically some form of jumping back a short amount of time then playing it again, possibly but not usually in slow motion). */
    KeyboardEventKey["InstantReplay"] = "InstantReplay";
    /** Opens content linked to the current program, if available and possible. */
    KeyboardEventKey["Link"] = "Link";
    /** Lists the current program. */
    KeyboardEventKey["ListProgram"] = "ListProgram";
    /** Toggles a display listing currently available live content or programs. */
    KeyboardEventKey["LiveContent"] = "LiveContent";
    /** Locks or unlocks the currently selected content or pgoram. */
    KeyboardEventKey["Lock"] = "Lock";
    /** Presents a list of media applications, such as photo viewers, audio and video players, and games. [1] */
    KeyboardEventKey["MediaApps"] = "MediaApps";
    /** The Audio Track key. */
    KeyboardEventKey["MediaAudioTrack"] = "MediaAudioTrack";
    /** Jumps back to the last-viewed content, program, or other media. */
    KeyboardEventKey["MediaLast"] = "MediaLast";
    /** Skips backward to the previous content or program. */
    KeyboardEventKey["MediaSkipBackward"] = "MediaSkipBackward";
    /** Skips forward to the next content or program. */
    KeyboardEventKey["MediaSkipForward"] = "MediaSkipForward";
    /** Steps backward to the previous content or program. */
    KeyboardEventKey["MediaStepBackward"] = "MediaStepBackward";
    /** Steps forward to the next content or program. */
    KeyboardEventKey["MediaStepForward"] = "MediaStepForward";
    /** Top Menu button; opens the media's main menu, such as on a DVD or Blu-Ray disc. */
    KeyboardEventKey["MediaTopMenu"] = "MediaTopMenu";
    /** Navigates into a submenu or option. */
    KeyboardEventKey["NavigateIn"] = "NavigateIn";
    /** Navigates to the next item. */
    KeyboardEventKey["NavigateNext"] = "NavigateNext";
    /** Navigates out of the current screen or menu. */
    KeyboardEventKey["NavigateOut"] = "NavigateOut";
    /** Navigates to the previous item. */
    KeyboardEventKey["NavigatePrevious"] = "NavigatePrevious";
    /** Cycles to the next channel in the favorites list. */
    KeyboardEventKey["NextFavoriteChannel"] = "NextFavoriteChannel";
    /** Cycles to the next saved user profile, if this feature is supported and multiple profiles exist. */
    KeyboardEventKey["NextUserProfile"] = "NextUserProfile";
    /** Opens the user interface for selecting on demand content or programs to watch. */
    KeyboardEventKey["OnDemand"] = "OnDemand";
    /** Starts the process of pairing the remote with a device to be controlled. */
    KeyboardEventKey["Pairing"] = "Pairing";
    /** A button to move the picture-in-picture view downward. */
    KeyboardEventKey["PinPDown"] = "PinPDown";
    /** A button to control moving the picture-in-picture view. */
    KeyboardEventKey["PinPMove"] = "PinPMove";
    /** Toggles display of th epicture-in-picture view on and off. */
    KeyboardEventKey["PinPToggle"] = "PinPToggle";
    /** A button to move the picture-in-picture view upward. */
    KeyboardEventKey["PinPUp"] = "PinPUp";
    /** Decreases the media playback rate. */
    KeyboardEventKey["PlaySpeedDown"] = "PlaySpeedDown";
    /** Returns the media playback rate to normal. */
    KeyboardEventKey["PlaySpeedReset"] = "PlaySpeedReset";
    /** Increases the media playback rate. */
    KeyboardEventKey["PlaySpeedUp"] = "PlaySpeedUp";
    /** Toggles random media (also known as "shuffle mode") on and off. */
    KeyboardEventKey["RandomToggle"] = "RandomToggle";
    /** A code sent when the remote control's battery is low. This doesn't actually correspond to a physical key at all. */
    KeyboardEventKey["RcLowBattery"] = "RcLowBattery";
    /** Cycles among the available media recording speeds. */
    KeyboardEventKey["RecordSpeedNext"] = "RecordSpeedNext";
    /** Toggles radio frequency (RF) input bypass mode on and off. RF bypass mode passes RF input directly to the RF output without any processing or filtering. */
    KeyboardEventKey["RfBypass"] = "RfBypass";
    /** Toggles the channel scan mode on and off; this is a mode which flips through channels automatically until the user stops the scan. */
    KeyboardEventKey["ScanChannelsToggle"] = "ScanChannelsToggle";
    /** Cycles through the available screen display modes. */
    KeyboardEventKey["ScreenModeNext"] = "ScreenModeNext";
    /** Toggles display of the device's settings screen on and off. */
    KeyboardEventKey["Settings"] = "Settings";
    /** Toggles split screen display mode on and off. */
    KeyboardEventKey["SplitScreenToggle"] = "SplitScreenToggle";
    /** Cycles among input modes on an external set-top box (STB). */
    KeyboardEventKey["STBInput"] = "STBInput";
    /** Toggles on and off an external STB. */
    KeyboardEventKey["STBPower"] = "STBPower";
    /** Toggles the display of subtitles on and off if they're available. */
    KeyboardEventKey["Subtitle"] = "Subtitle";
    /** Toggles display of teletext, if available. */
    KeyboardEventKey["Teletext"] = "Teletext";
    /** Cycles through the available video modes. */
    KeyboardEventKey["VideoModeNext"] = "VideoModeNext";
    /** Causes the device to identify itself in some fashion, such as by flashing a light, briefly changing the brightness of indicator lights, or emitting a tone. */
    KeyboardEventKey["Wink"] = "Wink";
    /** Toggles between full-screen and scaled content display, or otherwise change the magnification level. */
    KeyboardEventKey["ZoomToggle"] = "ZoomToggle";
    /** Presents a list of possible corrections for a word which was incorrectly identified. */
    KeyboardEventKey["SpeechCorrectionList"] = "SpeechCorrectionList";
    /** Toggles between dictation mode and command/control mode. This lets the speech engine know whether to interpret spoken words as input text or as commands. */
    KeyboardEventKey["SpeechInputToggle"] = "SpeechInputToggle";
    /** Closes the current document or message. Must not exit the application. */
    KeyboardEventKey["Close"] = "Close";
    /** Creates a new document or message. */
    KeyboardEventKey["New"] = "New";
    /** Opens an existing document or message. */
    KeyboardEventKey["Open"] = "Open";
    /** Prints the current document or message. */
    KeyboardEventKey["Print"] = "Print";
    /** Saves the current document or message. */
    KeyboardEventKey["Save"] = "Save";
    /** Starts spell checking the current document. */
    KeyboardEventKey["SpellCheck"] = "SpellCheck";
    /** Opens the user interface to forward a message. */
    KeyboardEventKey["MailForward"] = "MailForward";
    /** Opens the user interface to reply to a message. */
    KeyboardEventKey["MailReply"] = "MailReply";
    /** Sends the current message. */
    KeyboardEventKey["MailSend"] = "MailSend";
    /** The Calculator key, often labeled with an icon such as . This is often used as a generic application launcher key (APPCOMMAND_LAUNCH_APP2). */
    KeyboardEventKey["LaunchCalculator"] = "LaunchCalculator";
    /** The Calendar key, often labeled with an icon like . */
    KeyboardEventKey["LaunchCalendar"] = "LaunchCalendar";
    /** The Contacts key. */
    KeyboardEventKey["LaunchContacts"] = "LaunchContacts";
    /** The Mail key. This is often displayed as . */
    KeyboardEventKey["LaunchMail"] = "LaunchMail";
    /** The Media Player key. */
    KeyboardEventKey["LaunchMediaPlayer"] = "LaunchMediaPlayer";
    /** The Music Player key, often labeled with an icon such as . */
    KeyboardEventKey["LaunchMusicPlayer"] = "LaunchMusicPlayer";
    /** The My Computer key on Windows keyboards. This is often used as a generic application launcher key (APPCOMMAND_LAUNCH_APP1). */
    KeyboardEventKey["LaunchMyComputer"] = "LaunchMyComputer";
    /** The Phone key, to open the phone dialer application if one is present. */
    KeyboardEventKey["LaunchPhone"] = "LaunchPhone";
    /** The Screen Saver key. */
    KeyboardEventKey["LaunchScreenSaver"] = "LaunchScreenSaver";
    /** The Spreadsheet key. This key may be labeled with an icon such as  or that of a specific spreadsheet application. */
    KeyboardEventKey["LaunchSpreadsheet"] = "LaunchSpreadsheet";
    /** The Web Browser key. This key is frequently labeled with an icon such as  or the icon of a specific browser, depending on the device manufacturer. */
    KeyboardEventKey["LaunchWebBrowser"] = "LaunchWebBrowser";
    /** The WebCam key. Opens the webcam application. */
    KeyboardEventKey["LaunchWebCam"] = "LaunchWebCam";
    /** The Word Processor key. This may be an icon of a specific word processor application, or a generic document icon. */
    KeyboardEventKey["LaunchWordProcessor"] = "LaunchWordProcessor";
    /** The first generic application launcher button. */
    KeyboardEventKey["LaunchApplication1"] = "LaunchApplication1";
    /** The second generic application launcher button. */
    KeyboardEventKey["LaunchApplication2"] = "LaunchApplication2";
    /** The third generic application launcher button. */
    KeyboardEventKey["LaunchApplication3"] = "LaunchApplication3";
    /** The fourth generic application launcher button. */
    KeyboardEventKey["LaunchApplication4"] = "LaunchApplication4";
    /** The fifth generic application launcher button. */
    KeyboardEventKey["LaunchApplication5"] = "LaunchApplication5";
    /** The sixth generic application launcher button. */
    KeyboardEventKey["LaunchApplication6"] = "LaunchApplication6";
    /** The seventh generic application launcher button. */
    KeyboardEventKey["LaunchApplication7"] = "LaunchApplication7";
    /** The eighth generic application launcher button. */
    KeyboardEventKey["LaunchApplication8"] = "LaunchApplication8";
    /** The ninth generic application launcher button. */
    KeyboardEventKey["LaunchApplication9"] = "LaunchApplication9";
    /** The 10th generic application launcher button. */
    KeyboardEventKey["LaunchApplication10"] = "LaunchApplication10";
    /** The 11th generic application launcher button. */
    KeyboardEventKey["LaunchApplication11"] = "LaunchApplication11";
    /** The 12th generic application launcher button. */
    KeyboardEventKey["LaunchApplication12"] = "LaunchApplication12";
    /** The 13th generic application launcher button. */
    KeyboardEventKey["LaunchApplication13"] = "LaunchApplication13";
    /** The 14th generic application launcher button. */
    KeyboardEventKey["LaunchApplication14"] = "LaunchApplication14";
    /** The 15th generic application launcher button. */
    KeyboardEventKey["LaunchApplication15"] = "LaunchApplication15";
    /** The 16th generic application launcher button. */
    KeyboardEventKey["LaunchApplication16"] = "LaunchApplication16";
    /** Navigates to the previous content or page in the current Web view's history. */
    KeyboardEventKey["BrowserBack"] = "BrowserBack";
    /** Opens the user's list of bookmarks/favorites. */
    KeyboardEventKey["BrowserFavorites"] = "BrowserFavorites";
    /** Navigates to the next content or page in the current Web view's history. */
    KeyboardEventKey["BrowserForward"] = "BrowserForward";
    /** Navigates to the user's preferred home page. */
    KeyboardEventKey["BrowserHome"] = "BrowserHome";
    /** Refreshes the current page or contentl. */
    KeyboardEventKey["BrowserRefresh"] = "BrowserRefresh";
    /** Activates the user's preferred search engine or the search interface within their browser. */
    KeyboardEventKey["BrowserSearch"] = "BrowserSearch";
    /** Stops loading the currently displayed Web view or content. */
    KeyboardEventKey["BrowserStop"] = "BrowserStop";
    /** The decimal point key (typically . or , depending on the region. In newer browsers, this value to simply be the character generated by the decimal key (one of those two characters). [1] */
    KeyboardEventKey["Decimal"] = "Decimal";
    /** The 11 key found on certain media numeric keypads. */
    KeyboardEventKey["Key11"] = "Key11";
    /** The 12 key found on certain media numeric keypads. */
    KeyboardEventKey["Key12"] = "Key12";
    /** The numeric keypad's multiplication key, *. */
    KeyboardEventKey["Multiply"] = "Multiply";
    /** The numeric keypad's addition key, +. */
    KeyboardEventKey["Add"] = "Add";
    /** The numeric keypad's division key, /. */
    KeyboardEventKey["Divide"] = "Divide";
    /** The numeric keypad's subtraction key, -. */
    KeyboardEventKey["Subtract"] = "Subtract";
    /** The numeric keypad's places separator character (in the United States, this is a comma, but elsewhere it is frequently a period). */
    KeyboardEventKey["Separator"] = "Separator";
})(KeyboardEventKey || (KeyboardEventKey = {}));

export { KeyboardEventKey as K };
